import React, { useMemo } from "react";
import { Select } from "antd";

const FormSelect = ({
  name,
  placeholder,
  value,
  onChange,
  options = [],
  error,
  showSearch = true,
  filterOption,
  className = "",
  allowClear = true,
  ...rest
}) => {
  
  const optionValueSet = useMemo(
    () => new Set(options.map((o) => String(o?.value ?? ""))),
    [options]
  );


  let normalizedValue = value;
  if (
    normalizedValue === null ||
    normalizedValue === undefined ||
    normalizedValue === ""
  ) {
    normalizedValue = undefined;
  } else if (!optionValueSet.has(String(normalizedValue))) {
  
    normalizedValue = undefined;
  }


  const handleChange = (val, option) => {
    onChange?.(val ?? null, option);
  };

  const defaultFilterOption = (input, option) => {
    const label = String(option?.label ?? "").toLowerCase();
    const val = String(option?.value ?? "").toLowerCase();
    const term = String(input ?? "").toLowerCase();
    return label.includes(term) || val.includes(term);
  };

  return (
    <div style={{ width: "100%" }}>
      <Select
        showSearch={showSearch}
        placeholder={placeholder}
        value={normalizedValue}
        onChange={handleChange}
        options={options}
        filterOption={filterOption ?? defaultFilterOption}
        allowClear={allowClear}
        className={`w-100 ${error ? "input_error" : ""} ${className}`}
        getPopupContainer={(trigger) => trigger.parentNode}
        {...rest}
      />
      {error && <p style={{ color: "red", fontSize: "12px" }}>{error}</p>}
    </div>
  );
};

export default FormSelect;
